import { PromotionSettingCloseModal } from './PromotionSettingCloseModal'
import { withPromotionSettingCloseModal } from './withPromotionSettingCloseModal'

const ConnectedPromotionSettingCloseModal = withPromotionSettingCloseModal(
  PromotionSettingCloseModal
)

export { ConnectedPromotionSettingCloseModal as PromotionSettingCloseModal }
